import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Text,
  Box,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function LearnMoreAboutLeads({ isOpen, onClose }: Props) {
  return (
    <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody my="6">
          <Box>
            <Text fontWeight="semibold">
              What's Lead Finder and how can it help me find new leads?
            </Text>
            <br />
            <Text>
              Lead Finder uses our latest and most advanced AI model. It
              identifies new leads for you, based on a list of people you
              consider to be in your target audience.
            </Text>
            <br />
            <Text>
              Lead Finder starts with a prompt you submit.
              Then it explores Twitter / X to find relevant accounts for
              you to turn into clients, users, subscribers.
            </Text>
          </Box>
          <br />
          <Box>
            <Text fontWeight="semibold">How does it work?</Text>
            <br />
            <Text>
              Lead Finder uses "watchers". A "watcher" is like a set of rules
              and information which we will use to find potential leads for you
              and make them available to you.
            </Text>
            <br />
            <Text>Each watcher is made of:</Text>
            <br />
            <UnorderedList>
              <ListItem>
                a prompt (your definition of what definition of what a lead is, should be as specific as possible)
              </ListItem>
              <ListItem>
                an "output" list (a list where the watcher will export the leads
                it finds)
              </ListItem>
              <ListItem>
                extra criterias (number of followers, locations, etc.)
              </ListItem>
            </UnorderedList>
            <br />
            <Text>
              Once you create a "watcher", it will run continuously and will
              keep trying to find new leads for you until you delete it. Leads
              are generated over time, so it's perfectly normal that you don't
              get leads right after creating your first watcher. Come back a few
              hours later, and it probably started populating.
            </Text>
            <br />
            <Text>
              If you choose to, we will send you a daily email recap to tell you
              how many leads we found on that day.
            </Text>
          </Box>
          <br />
          <Box>
            <Text fontWeight="semibold">OK, I got leads. What now?</Text>
            <br />
            <Text>
              There's a few ways you can use the leads Tweet Hunter finds for
              you.
            </Text>
            <br />
            <Text>
              First off, you can engage with their content. Just head over to
              the Engage section (people tab) and select the list.
            </Text>
            <br />
            <Text>
              You can also send them DMs straight on Twitter / X. but be extra
              cautious. People don't like it when you spam them. If you're going
              to do that, we recommend a personal, thoughtful approach. It's far
              better (and safer) than copy/pasting.
            </Text>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
